import { TextField } from 'mui-rff';
import React from 'react';

import { Stack } from '@mui/material';

type Props = {
  name: string;
};
export default function SendEmailTemplateMessageForm({ name }: Props) {
  return (
    <Stack spacing={3}>
      <Stack spacing={2} pt={2}>
        <TextField
          size="small"
          name={`${name}.sendEmailTemplateMessage.toTemplate`}
          label="To"
          placeholder="{{user.email}}"
        />
        <TextField size="small" name={`${name}.sendEmailTemplateMessage.ccTemplate`} label="cc" />
        <TextField size="small" name={`${name}.sendEmailTemplateMessage.bccTemplate`} label="bcc" />
      </Stack>
    </Stack>
  );
}
